import React, { useContext, useState, useEffect, useRef, useCallback, memo } from "react";
import Cards from "./Cards";
import Form from "react-bootstrap/Form";
import AppCards from "./AppCards";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Taches from "../Tâches/Taches";
import ClearIcon from "@mui/icons-material/Clear";
import "./style/dashboard.css";
import TuneIcon from "@mui/icons-material/Tune";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Filler,
  plugins,
} from "chart.js";
import ReactApexChart from "react-apexcharts";
import { AuthContext } from "../context/AuthContext";
import STcontext from "../context/STcontext";
import GpsTable from "./Gpstable";
import SimTable from "./SimTable";
import pusher from "../../pusher";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  plugins,
  Title,
  Filler
);

function Dashboard() {
  const { USE } = useContext(AuthContext);
  const {
    getTask,
    statisticsTasksDashboard,
    getAppareil,
    getAppareilInstalle,
    filteringPerDate,
    appareilInstalle,
    isFilterTask,
    setIsFilterTask,
    statisticsTasks,
    getStatisticsTasks,
    getStatisticsTasksTechnicien,
    handleChangeDateStatistics,
    taskToConfirmed,
    getTasktoConfirmed,
  } = useContext(STcontext);

  const [loadingFilter, setLoadingFilter] = useState(false);
  
  const hasFetched = useRef(false); // ← empêche double appel StrictMode
  const [tasksToConfirm, setTasksToConfirm] = useState(0); // État local pour les tâches à confirmer


  const [filterTask, setFilterTask] = useState({
    date: {
      date_presionnel_début: "1",
      date_presionnel_fin: "1",
    },
    profil: "1",
  });

  // UN seul useEffect au montage (au lieu de 4)
   useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const { date_presionnel_début, date_presionnel_fin } = filterTask.date;

    Promise.all([
      // getTasktoConfirmed(),
      getTask(date_presionnel_début, date_presionnel_fin, filterTask.profil),
      getAppareilInstalle(date_presionnel_début, date_presionnel_fin),
      getStatisticsTasksTechnicien(),
    ]).then(([confirmedTasks]) => {
      if (confirmedTasks) {
        setTasksToConfirm(confirmedTasks.length || 0);
      }
    });

    const channel = pusher.subscribe("Installer_realTime");
    channel.bind("realTimeData", () => {
      const { date_presionnel_début, date_presionnel_fin } = filterTask.date;
      Promise.all([
        getTask(date_presionnel_début, date_presionnel_fin, filterTask.profil),
        getAppareilInstalle(date_presionnel_début, date_presionnel_fin),
        getTasktoConfirmed(), 
      ]).then(([,, confirmedTasks]) => {
        if (confirmedTasks) {
          setTasksToConfirm(confirmedTasks.length || 0);
        }
      });
    });

    return () => {
      pusher.unsubscribe("Installer_realTime"); 
    };
  }, []);

   useEffect(() => {
    if (taskToConfirmed) {
      setTasksToConfirm(taskToConfirmed.length || 0);
    }
  }, [taskToConfirmed]);
  // Filtre par date sessionStorage — séparé car dépend de isFilterTask
  useEffect(() => {
    if (!isFilterTask) return;
    const dateFilter = JSON.parse(sessionStorage.getItem("dateFilter"));
    if (!dateFilter) return;
    setFilterTask((prev) => ({ ...prev, date: dateFilter }));
    filteringPerDate(
      dateFilter.date_presionnel_début,
      dateFilter.date_presionnel_fin,
      filterTask.profil
    );
  }, [isFilterTask]);

  // Stats — dépend uniquement des valeurs primitives, pas de l'objet entier
  useEffect(() => {
    getStatisticsTasksTechnicien();
  }, [
    getStatisticsTasks.categoreyTask,  // ← primitives au lieu de l'objet
    getStatisticsTasks.etaTask,
    getStatisticsTasks.date,
  ]);

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    setFilterTask((prev) => ({
      ...prev,
      date: { ...prev.date, [name]: value },
    }));
  };

  // useCallback évite de recréer la fonction à chaque render
  const clearFilterTaskTechnicien = useCallback(() => {
    const defaultDate = { date_presionnel_début: "1", date_presionnel_fin: "1" };
    setIsFilterTask(false);
    setFilterTask({ date: defaultDate, profil: "1" });
    sessionStorage.clear();
    Promise.all([
      getTask("1", "1", "1"),
      getAppareilInstalle("1", "1"),
      getStatisticsTasksTechnicien(),
    ]);
  }, []);

  // ... options chart et JSX identiques
  const options = {
    chart: {
      type: "bar",
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    xaxis: {
      type: "datetime",
      categories: statisticsTasks[0]?.labelArray,
    },
    legend: {
      position: "right",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div>
      <div className="dashcontainer">
        <Row className="mb-3">
          {USE.profil_id != 28 ? (
            <Form.Group as={Col} controlId="validationCustom04">
              <Form.Select
                onChange={(e) =>
                  setFilterTask((old) => {
                    return {
                      ...old,
                      profil: e.target.value,
                    };
                  })
                }
              >
                <option disabled>Veuillez choisir un profil</option>
                <option value="1">Technicien</option>
                <option value="2">Support technique</option>
              </Form.Select>
            </Form.Group>
          ) : (
            ""
          )}

          <Form.Group as={Col}>
            <Form.Control
              type="date"
              name="date_presionnel_début"
              onChange={handleChangeDate}
              value={filterTask.date.date_presionnel_début}
            ></Form.Control>
          </Form.Group>

          <Form.Group as={Col}>
            <Form.Control
              type="date"
              name="date_presionnel_fin"
              onChange={handleChangeDate}
              value={filterTask.date.date_presionnel_fin}
            ></Form.Control>
          </Form.Group>
          <Form.Group
            className="btn-validate dashboard-Filter-buttons"
            as={Col}
            md="4"
            controlId="validationCustom04"
          >
            <Button
              type="button"
             
               onClick={async (e) => {
                  setLoadingFilter(true);
                  try {
                    await filteringPerDate(
                      filterTask.date.date_presionnel_début,
                      filterTask.date.date_presionnel_fin,
                      filterTask.profil
                    );
                  } finally {
                    setLoadingFilter(false);
                  }
                }}
                disabled={loadingFilter}
              variant="primary"
              data-test="dd"
            >
               {loadingFilter ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Chargement...
                  </>
                ) : (
              <>
              <TuneIcon />
              Filtrer
              </>
              )}
            </Button>
            <Button variant="danger" onClick={clearFilterTaskTechnicien}>
              {" "}
              <ClearIcon />
              Annule
            </Button>
          </Form.Group>
        </Row>
      </div>

      <h4>Statistiques des tâches </h4>
      <br />
      <Cards data={statisticsTasksDashboard}  tasksToConfirm={tasksToConfirm}/>
      <br /> <br />
      <h4>Statistiques des appareils</h4>
      <br />
      <AppCards data={appareilInstalle} />
      <div style={{ display: "flex", justifyContent: "center", width: "95%" }}>
        <div className="chart" style={{ padding: "20px", width: "100%" }}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h5 className="chart-title">Stats tâche</h5>
            </div>
            <div style={{ display: "flex", gap: "30px" }}>
              <Form.Select
                color="success"
                style={{
                  paddingLeft: "1.2rem",
                  marginBottom: "1.2rem",
                }}
                aria-label="Default select example"
                name="categoreyTask"
                onChange={handleChangeDateStatistics}
              >
                <option disabled>Type du tâche</option>
                <option value="1" default>
                  Installation
                </option>
                <option value="2">Désinstallation</option>
                <option value="3">Réinstallation</option>
                <option value="4">Réparation SIM</option>
                <option value="5">Réparation GPS </option>
                <option value="6">Réparation Relais</option>
              </Form.Select>
              <Form.Select
                color="success"
                style={{
                  paddingLeft: "1.2rem",
                  marginBottom: "1.2rem",
                }}
                aria-label="Default select example"
                name="date"
                onChange={handleChangeDateStatistics}
              >
                <option disabled>date</option>

                <option value="weeks" default>
                  jours
                </option>
                <option value="months">semaines</option>
                <option value="years">mois</option>
                <option value="allYears">années</option>
              </Form.Select>
            </div>
          </div>

          <ReactApexChart
            options={options}
            series={statisticsTasks}
            type="bar"
            height={500}
          />
        </div>
      </div>
      <div className="chart-dash">
        <div style={{ marginTop: "2rem", minWidth: "20rem" }}>
          <GpsTable GpsInstall={appareilInstalle} />
        </div>
        <div style={{ marginTop: "2rem", minWidth: "20rem" }}>
          <SimTable SimInstall={appareilInstalle} />
        </div>
      </div>
      <div className="tâches-dash">
        <Taches />
      </div>
    </div>
  );
}

export default memo(Dashboard); 